import { sequenceMap } from '../../../../../../../components/displays/alerts/components/addAlertComponent/addAlertForm/formComponents/setup/setupDetails/setupDetailsModules/candlePattern/candlePatternMap';
import { v4 as uuidv4 } from 'uuid';
import { isPartialOutsideCandle } from './isPartialOutsideCandle';

export function candlePatternDetailParser(_root, softOrder) {
  const tacticValue = softOrder.value.tacticValue;
  const patterns = tacticValue.patterns ?? null;
  if (!patterns || patterns.length < 1) return null;
  return patterns.map((pattern) => {
		const length = pattern.length
    const lastSequence = pattern[length - 1];

    const isPartial = isPartialOutsideCandle(lastSequence, tacticValue);
    let triggerPrice = {
      priceToBreak: false,
      priceToBreakHigh: false,
      priceToBreakLow: false,
    };
    if (lastSequence.currentSequence === true) {
      if (isPartial) {
        if (isPartial.displayTriggerPrice) {
          triggerPrice = {
            ...triggerPrice,
            [isPartial.displayTriggerPrice]:
              lastSequence[isPartial.displayTriggerPrice],
          };
        }
      } else {
				const obj = extractPricesToBreak(lastSequence);
        triggerPrice = {
          ...triggerPrice,
          ...obj,
        };
      }
    }
		const details = pattern.map((sequence, i) => {
			let achieved = false;
			const nextIndex = i + 1;
			if (i !== length - 1 && pattern[nextIndex].currentSequence) {
				achieved = true;
			}
			if (i === length - 1 && isPartial) {
				return {
					id: uuidv4(),
					current: sequence.currentSequence,
					sequence: sequenceMap[sequence.candleSequence],
					showPartialBox: isPartial.showPartialBox,
					achieved,
				};
			}
			return {
				id: uuidv4(),
				current: sequence.currentSequence,
				sequence: sequenceMap[sequence.candleSequence],
				showPartialBox: false,
				achieved,
			};
		});
		return {
			details,
			triggerPrice,
		};
  });
}
function extractPricesToBreak(sequenceObject) {
	const result = {};
	if(sequenceObject.priceToBreak) result.priceToBreak = sequenceObject.priceToBreak;
	if(sequenceObject.priceToBreakHigh) result.priceToBreakHigh = sequenceObject.priceToBreakHigh;
	if(sequenceObject.priceToBreakLow) result.priceToBreakLow = sequenceObject.priceToBreakLow;
	return result;
}


//   const firstPattern = tacticValue.patterns[0];
//   const patternLength = firstPattern.length;
//   const lastSequence = firstPattern[patternLength - 1];
//   let isPartial = isPartialOutsideCandle(lastSequence, tacticValue);

//   let triggerPrice = {
//     priceToBreak: false,
//     priceToBreakHigh: false,
//     priceToBreakLow: false,
//   };

//   // function needs to decide whether the distance to trigger should be shown, if so, which distance to trigger, and it should add a bool to the sequence object to show a partial box.
//   if (lastSequence.currentSequence === true) {
//     if (isPartial) {
//       console.log('isPartial', isPartial);
//       const sequenceName = tacticValue.CANDLE_PATTERN.sequenceNames[0];
//       if (isPartial.displayTriggerPrice) {
//         triggerPrice = {
//           ...triggerPrice,
//           [isPartial.displayTriggerPrice]:
//             tacticValue.CANDLE_PATTERN[sequenceName][
//               isPartial.displayTriggerPrice
//             ],
//         };
//       }
//     } else {
//       triggerPrice = {
//         ...triggerPrice,
//         ...lastSequence
//       };
//     }
//   }
//   const length = firstPattern.length;
//   const details = firstPattern.map((sequence, i) => {
//     let achieved = false;
//     const nextIndex = i + 1;
//     if (i !== length - 1 && firstPattern[nextIndex].currentSequence) {
//       achieved = true;
//     }
//     if (i === length - 1 && isPartial) {
//       return {
//         id: uuidv4(),
//         current: sequence.currentSequence,
//         sequence: sequenceMap[sequence.candleSequence],
//         showPartialBox: isPartial.showPartialBox,
//         achieved,
//       };
//     }
//     return {
//       id: uuidv4(),
//       current: sequence.currentSequence,
//       sequence: sequenceMap[sequence.candleSequence],
//       showPartialBox: false,
//       achieved,
//     };
//   });
//   return {
//     details,
//     triggerPrice,
//   };
// }

/*
{
	"messageType": "softOrder",
	"tradePlanId": 0,
	"tradePlanType": "BASIC_TRADING_SYSTEM",
	"value": {
		"timeStamp": "1651864784897",
		"tacticId": "CANDLE_PATTERN|BASIC_TRADING_SYSTEM16518647842831",
		"tactic": "CANDLE_PATTERN",
		"symbol": "XYZ",
		"tacticValue": {
			"breakBy": 0.05,
			"patterns": [
				[{
					"terminateOnFail": false,
					"restartOnFail": false,
					"candleSequence": "BREAK_LOW",
					"currentSequence": true,
					"currentSequenceName": "BREAK_LOW",
					"priceToBreak": 99.95
				}, {
					"terminateOnFail": false,
					"restartOnFail": true,
					"candleSequence": "BREAK_HIGH",
					"currentSequence": false
				}],
				[{
					"terminateOnFail": false,
					"restartOnFail": false,
					"candleSequence": "OUTSIDE_CANDLE",
					"currentSequence": false
				}, {
					"terminateOnFail": false,
					"restartOnFail": true,
					"candleSequence": "INSIDE_CANDLE",
					"currentSequence": false
				}, {
					"terminateOnFail": false,
					"restartOnFail": true,
					"candleSequence": "BREAK_HIGH",
					"currentSequence": true,
					"currentSequenceName": "BREAK_HIGH",
					"priceToBreak": 103.05
				}]
			]
		}
	}
}
{
	"messageType": "softOrder",
	"tradePlanId": 0,
	"tradePlanType": "ALERT",
	"value": {
		"timeStamp": "1651864543528",
		"tacticId": "CANDLE_PATTERN|ALERT16518645426521",
		"tactic": "CANDLE_PATTERN",
		"symbol": "XYZ",
		"tacticValue": {
			"breakBy": 0.0,
			"score": 1.0,
			"patterns": [
				[{
					"terminateOnFail": false,
					"restartOnFail": false,
					"candleSequence": "OUTSIDE_CANDLE",
					"currentSequence": true,
					"currentSequenceName": "OUTSIDE_CANDLE_UP",
					"priceToBreakHigh": 101.0,
					"brokeHigh": true,
					"priceToBreakLow": 99.0,
					"brokeLow": true
				}]
			]
		}
	}
}
*/
